import debounce from 'lodash/debounce'
import { animate, stagger } from 'animejs'
import NavigationScrollHandler from '../utils/_navigation-scroll'

export default function Navigation () {
  const MAIN_HEADER = document.getElementById('main_header')

  if (MAIN_HEADER) {
    const RESPONSIVE_NAVIGATION = new ResponsiveNavigation('main_nav', 'navigation-toggle')
    const RESPONSIVE_NAVIGATION_SCROLL_HANDLER = new NavigationScrollHandler({
      scrollDistance: 80,
      headerElement: MAIN_HEADER,
      onEnter: () => {
        !document.body.classList.contains('header-scrolled') && document.body.classList.add('header-scrolled')
        !MAIN_HEADER.classList.contains('mtt-header--scrolled') && MAIN_HEADER.classList.add('mtt-header--scrolled')
      },
      onExit: () => {
        document.body.classList.contains('header-scrolled') && document.body.classList.remove('header-scrolled')
        MAIN_HEADER.classList.contains('mtt-header--scrolled') && MAIN_HEADER.classList.remove('mtt-header--scrolled')
      }
    })
  }
}

class ResponsiveNavigation {
  constructor (ID, TOGGLE_ID) {
    this.ID = ID
    this.TOGGLE_ID = TOGGLE_ID
    this.BREAKPOINT = 1160
    this.canToggle = true

    // Elements
    this.NAV = document.getElementById(ID)
    this.MAIN_HEADER = document.getElementById('main_header')
    this.NAV_OVERLAY = document.getElementById('overlay')
    this.NAV_TOGGLE = document.getElementById(TOGGLE_ID)

    this.dropdownArrows()
    this.bindEventHandlers()
  }

  bindEventHandlers () {
    // close nav
    this.NAV_OVERLAY.addEventListener('click', () => this.closeNavigation())
    window.addEventListener('resize', debounce(() => this.closeNavigation(), 300))
    document.addEventListener('keydown', (e) => e.keyCode === 27 && this.closeNavigation())
    this.submenuOnClick()

    // toggle nav
    this.NAV_TOGGLE.addEventListener('click', () => this.toggleNavigation())
  }

  toggleNavigation () {
    // Check if toggleable
    this.toggleable()

    // Toggle elements
    this.NAV_TOGGLE.classList.toggle('open')
    this.NAV.classList.toggle('open')
    this.NAV_OVERLAY.classList.toggle('show')
  }

  // Check if menu is toggleable
  toggleable () {
    if (!this.canToggle) return
    this.canToggle = false
    setTimeout(() => { this.canToggle = true }, 200)
  }

  // Close the navigation
  closeNavigation () {
    this.NAV_TOGGLE.classList.remove('open')
    this.NAV.classList.remove('open')
    this.NAV_OVERLAY.classList.remove('show')
  }

  // Append dropdown arrows for items with children
  dropdownArrows () {
    const DROPDOWN_ARROWS = document.querySelectorAll('.mtt-header__dropdown-arrow')

    for (let i = 0; i < DROPDOWN_ARROWS.length; i++) {
      const DROPDOWN_ARROW = DROPDOWN_ARROWS[i]
      DROPDOWN_ARROW.addEventListener('click', this.toggleSubMenu.bind(this))
    }
  }

  // Close menu on submenu item click
  submenuOnClick () {
    const ALL_MENU_ITEMS = document.querySelectorAll('#menu-main-menu .current_page_item li')
    for (let i = 0; i < ALL_MENU_ITEMS.length; i++) {
      ALL_MENU_ITEMS[i].addEventListener('click', () => this.closeNavigation())
    }
  }

  // Toggle submenu
  toggleSubMenu (e) {
    if (this.getScreenWidth() <= 1160) {
      const THIS = e.target
      const MENU_WRAP = THIS.parentNode
      MENU_WRAP.classList.toggle('menu-open')

      let submenuWrap = MENU_WRAP.querySelector('.sub-menu')

      if (submenuWrap) {
        const SUBMENU_ITEMS = submenuWrap.querySelectorAll('.menu-item')

        if (MENU_WRAP.classList.contains('menu-open')) {
          this.subMenuAnimation(SUBMENU_ITEMS)
        } else {
          this.hideSubMenuItems(SUBMENU_ITEMS)
        }
      }
    }
  }

  subMenuAnimation (targetElements) {
    animate(targetElements, {
      translateX: ['-50px', 0],
      opacity: [0, 1],
      ease: 'outElastic(1, 0.5)',
      duration: 700,
      delay: stagger(75)
    })
  }

  hideSubMenuItems (targetElements) {
    for (let i = 0; i < targetElements.length; i++) {
      const SUBMENU_ITEM = targetElements[i]
      SUBMENU_ITEM.style.transform = 'translateX(-100%)'
    }
  }

  /************************************************
   * Helpers
   ***********************************************/

  getScreenWidth () {
    return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
  }

  getScrollY () {
    return (window.pageYOffset || document.documentElement.scrollTop) - (document.documentElement.clientTop || 0)
  }

  getHeaderHeight () {
    return this.MAIN_HEADER.getBoundingClientRect().height
  }
}
